import { render, staticRenderFns } from "./manual_rating_judge_table.vue?vue&type=template&id=20e93bfb&scoped=true"
import script from "./manual_rating_judge_table.vue?vue&type=script&lang=js"
export * from "./manual_rating_judge_table.vue?vue&type=script&lang=js"
import style0 from "./manual_rating_judge_table.vue?vue&type=style&index=0&id=20e93bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e93bfb",
  null
  
)

export default component.exports